export const CGM_HUISARTS = {
  id: 'http://cgmhuisarts.cgm.nl/fhir/NamingSystem/patientID',
  idType: 'identifier',
  label: 'CGM Huisarts Patient ID',
  group: 'Patient'
};

export const BSN = {
  id: 'http://fhir.nl/fhir/NamingSystem/bsn',
  idType: 'identifier',
  label: 'BSN',
  group: 'Patient'
};

const CGM_ZORGDOSSIER = {
  id: 'http://cgmzorgdossier.cgm.nl/fhir/NamingSystem/patientID',
  idType: 'identifier',
  label: 'CGM Zorgdossier Patient ID',
  group: 'Patient'
};

const EXTERNAL_NUMBER = {
  id: 'https://cgm.com/nl/externNumber',
  idType: 'identifier',
  label: 'Extern Number / Weblink ID / Pharmeon ID',
  group: 'Patient'
};

const CGM_UID = {
  id: 'https://cgm.com/nl/cgmUid',
  idType: 'identifier',
  label: 'CGM UID',
  group: 'Patient'
};

const URA = {
  id: 'http://fhir.nl/fhir/NamingSystem/ura',
  idType: 'identifier',
  label: 'URA',
  group: 'Organization'
};

const AGB = {
  id: 'http://fhir.nl/fhir/NamingSystem/agb-z',
  idType: 'identifier',
  label: 'AGB',
  group: 'Organization'
};

const MED_MIJ_NAAM = {
  id: 'http://www.medmij.nl/id/medmijnaam',
  idType: 'identifier',
  label: 'MedMij Naam',
  group: 'Organization'
};

const AORTA_APP_ID = {
  id: 'http://fhir.nl/fhir/NamingSystem/aorta-app-id',
  idType: 'identifier',
  label: 'AORTA Application ID',
  group: 'Organization'
};

const AORTA_APP_ID_OID = {
  id: 'urn:oid:2.16.840.1.113883.2.4.6.6',
  idType: 'identifier',
  label: 'AORTA Application ID (OID)',
  group: 'Organization'
};

export const PATIENT_FHIR_ID = {
  id: 'patientFhirId',
  idType: 'fhirId',
  label: 'Patient FHIR ID',
  group: 'Patient'
};

export const ORGANIZATION_FHIR_ID = {
  id: 'organizationFhirId',
  idType: 'fhirId',
  label: 'Organization FHIR ID',
  group: 'Organization'
};

export const PATIENT = 'Patient';
export const ORGANIZATION = 'Organization';

export const SEARCH_PARAMETER_TYPES = [
  {groupLabel: PATIENT, types: [PATIENT_FHIR_ID, BSN, CGM_HUISARTS, CGM_ZORGDOSSIER, EXTERNAL_NUMBER, CGM_UID]},
  {groupLabel: ORGANIZATION, types: [ORGANIZATION_FHIR_ID, URA, AGB, MED_MIJ_NAAM, AORTA_APP_ID, AORTA_APP_ID_OID]}
];

export const IDENTIFIER_TYPE_TO_INPUT_LABEL = {};

SEARCH_PARAMETER_TYPES.forEach((group) => {
  group.types.forEach((type) => {
    Object.defineProperty(IDENTIFIER_TYPE_TO_INPUT_LABEL, type.id, {
      value: type.label
    });
  });
});

export const FIRST_PERMITTED_DISCLOSURE = 'FirstPermittedEhrDisclosure';
export const PROHIBITED_PERIOD_DISCLOSURE = 'DisclosureProhibited';
export const PROHIBITED_UNDER_AGE_16_DISCLOSURE = 'UnderAge16Prohibited';
export const BIRTH_DATE_MISSING = 'BirthDateMissing';
export const SEND_VITAL_SIGNS_ALLOWED_PERIOD = 'SendVitalSignsAllowedPeriod';
export const ORGANIZATION_RESTRICTION = 'OrganizationRestriction';
export const AGENDA_REFERENCE = 'AgendaReference';
export const ORGANIZATION_SEND_VITAL_SIGNS_ALLOWED_PERIOD = 'OrganizationSendVitalSignsAllowedPeriod';
export const GREATER_AGE_16_ALLOWED = 'GreaterAge16Allowed';
export const SEND_VITAL_SIGNS_PERIOD_MISSING = 'SendVitalSignsPeriodMissing';
export const PATIENT_RESTRICTION = 'PatientRestriction';

export const ORGANIZATION_TYPES = {
  V4: 'Hospital',
  V5: 'University Medical Center',
  V6: 'General Hospital',
  Z4: 'Independent treatment center',
  Z5: 'Diagnostic center',
  B2: 'Ultrasound center',
  X3: 'Nursing or care facility',
  R5: 'Nursing home',
  M1: 'Nursing home',
  A1: 'Pharmacy institution',
  J8: 'Public pharmacy',
  K9: 'Independently operating hospital pharmacy',
  H1: 'General practitioner institution',
  Z3: 'General practice',
  K3: 'Dispensing general practice',
  N6: 'GP post',
  L1: 'Laboratory',
  P4: 'Polyclinic',
  R8: 'Rehabilitation center',
  P6: 'Preventive health care',
  G5: 'Mental healthcare',
  G6: 'Mental disability care',
  T2: 'Home care',
  JGZ: 'Youth health care',
  G3: 'Midwifery practice'
};

export const REFERENCE_TYPES = {
  'fhir-id': 'FHIR ID',
  identifier: 'Identifier'
};

export const INVALID_TOKEN_ERROR = 'invalidToken';
export const BAD_SYNTAX_ERROR = 'badSyntax';
export const FORBIDDEN_ERROR_STATUS_CODE = 403;

export const RESTRICTION_TYPES = {
  accessRestriction: 'Data access'
};

export const ALLOWANCES_TYPES = {
  sendAllowance: 'Data send'
};
